import { apiConf as api } from 'commons'

export const fetchProducts = (uuid, usrId, uorIdMst, landId) => {
  return api.superFetch({
    url: `listecotations?usrid=${usrId}&uoridmst=${uorIdMst}&lanId=${landId}`,
    uuid: uuid,
  })
}
